import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

import useStyles from './BannerBlank.styles';
import { Container, Box, SvgIcon, MenuItem, Typography } from '@mui/material';

export default function BannerBlank(props: {
  children:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
  bgColor?: string;
}) {
  const classes = useStyles(props);

  const socials = [
    {
      title: 'Facebook',
      url: 'https://www.facebook.com/deliverinperson',
      icon: (
        <path d='M29.5406 15.7603C29.5406 7.60353 22.9272 0.990234 14.7703 0.990234C6.6134 0.990234 0 7.60353 0 15.7603C0 23.133 5.401 29.2429 12.4624 30.3507V20.0301H8.71201V15.7591H12.4624V12.5072C12.4624 8.80606 14.6681 6.7604 18.0419 6.7604C19.6568 6.7604 21.348 7.04965 21.348 7.04965V10.6843H19.4845C17.6493 10.6843 17.0769 11.8229 17.0769 12.9909V15.7603H21.1732L20.5184 20.0313H17.0769V30.3519C24.1396 29.2429 29.5406 23.1318 29.5406 15.7603H29.5406Z' />
      ),
    },
    {
      title: 'Instagram',
      url: 'https://www.instagram.com/deliverinperson/',
      icon: (
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.5263 0.990234C11.5137 0.990234 11.0127 1.00869 9.43722 1.07885C7.86419 1.1527 6.79334 1.4001 5.85173 1.76566C4.88058 2.1423 4.05591 2.64817 3.23493 3.46914C2.41395 4.29011 1.90684 5.11354 1.53142 6.0859C1.16586 7.02749 0.917221 8.09832 0.844601 9.67133C0.770751 11.2468 0.755981 11.7478 0.755981 15.7603C0.755981 19.7728 0.774441 20.2738 0.844601 21.8493C0.918451 23.421 1.16585 24.4931 1.53142 25.4347C1.90806 26.4046 2.41394 27.2305 3.23493 28.0514C4.05591 28.8712 4.87936 29.3795 5.85173 29.7549C6.79457 30.1193 7.86541 30.3691 9.43722 30.4417C11.0127 30.5156 11.5137 30.5304 15.5263 30.5304C19.5389 30.5304 20.0398 30.5119 21.6153 30.4417C23.1871 30.3679 24.2592 30.1193 25.2008 29.7549C26.1707 29.3783 26.9966 28.8712 27.8176 28.0515C28.6374 27.2305 29.1457 26.4083 29.5211 25.4347C29.8854 24.4931 30.1353 23.421 30.2079 21.8493C30.2818 20.2738 30.2966 19.7728 30.2966 15.7603C30.2966 11.7478 30.2781 11.2468 30.2079 9.67133C30.1341 8.09955 29.8855 7.02626 29.5211 6.0859C29.1445 5.11477 28.6374 4.29011 27.8176 3.46914C26.9966 2.64817 26.1744 2.14107 25.2008 1.76566C24.2592 1.4001 23.1871 1.15147 21.6153 1.07885C20.0398 1.005 19.5389 0.990234 15.5263 0.990234ZM15.5263 3.64884C19.4687 3.64884 19.9389 3.66853 21.4959 3.73623C22.936 3.80393 23.7176 4.04271 24.2371 4.24703C24.9288 4.51412 25.4187 4.83414 25.9381 5.34986C26.4538 5.86681 26.7738 6.35792 27.0409 7.04965C27.2428 7.56906 27.4841 8.35065 27.5493 9.79073C27.6194 11.349 27.6354 11.8167 27.6354 15.7603C27.6354 19.7039 27.617 20.1729 27.5444 21.7299C27.4693 23.17 27.2293 23.9515 27.0262 24.471C26.7505 25.1627 26.4366 25.6526 25.9196 26.172C25.4039 26.6877 24.9054 27.0077 24.2211 27.2748C23.7041 27.4767 22.9102 27.7179 21.4701 27.7831C19.902 27.8533 19.4404 27.8693 15.4893 27.8693C11.5371 27.8693 11.0755 27.8508 9.50861 27.7782C8.06728 27.7031 7.27337 27.4631 6.75641 27.26C6.05605 26.9843 5.57479 26.6705 5.05906 26.1535C4.54087 25.6378 4.20977 25.1393 3.95129 24.455C3.7482 23.938 3.50941 23.1441 3.43433 21.704C3.37894 20.1532 3.35925 19.6744 3.35925 15.7419C3.35925 11.8081 3.37894 11.3281 3.43433 9.75874C3.50941 8.31866 3.7482 7.526 3.95129 7.00904C4.20977 6.30746 4.54087 5.82744 5.05906 5.30925C5.57479 4.79353 6.05605 4.4612 6.75641 4.20396C7.27337 3.99964 8.05004 3.75963 9.49014 3.68578C11.0595 3.63039 11.5211 3.61193 15.4709 3.61193L15.5263 3.64886L15.5263 3.64884ZM15.5263 8.17587C11.3352 8.17587 7.94173 11.573 7.94173 15.7603C7.94173 19.9513 11.3389 23.3447 15.5263 23.3447C19.7173 23.3447 23.1108 19.9476 23.1108 15.7603C23.1108 11.5693 19.7136 8.17587 15.5263 8.17587ZM15.5263 20.6837C12.8061 20.6837 10.6028 18.4805 10.6028 15.7603C10.6028 13.0402 12.8061 10.8369 15.5263 10.8369C18.2465 10.8369 20.4497 13.0401 20.4497 15.7603C20.4497 18.4805 18.2465 20.6837 15.5263 20.6837ZM25.1836 7.87678C25.1836 8.8553 24.3884 9.64919 23.4111 9.64919C22.4326 9.64919 21.6387 8.85407 21.6387 7.87678C21.6387 6.89949 22.4338 6.1056 23.4111 6.1056C24.3872 6.10437 25.1836 6.89949 25.1836 7.87678Z'
        />
      ),
    },
    {
      title: 'Linkedin',
      url: 'https://www.linkedin.com/company/deliverinperson',
      icon: (
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.6793 26.1634H21.3048V19.3088C21.3048 17.6743 21.2716 15.5708 19.0253 15.5708C16.7445 15.5708 16.3962 17.3493 16.3962 19.1882V26.1634H12.0217V12.0678H16.2239V13.9891H16.2805C16.8676 12.8814 18.2954 11.7121 20.4285 11.7121C24.8608 11.7121 25.6805 14.6292 25.6805 18.4263V26.1634H25.6793ZM7.08104 10.1391C5.67294 10.1391 4.54178 8.9993 4.54178 7.59738C4.54178 6.19668 5.67417 5.05816 7.08104 5.05816C8.48422 5.05816 9.62153 6.19669 9.62153 7.59738C9.62153 8.99931 8.48299 10.1391 7.08104 10.1391ZM9.27443 26.1634H4.88765V12.0678H9.27443V26.1634ZM27.8678 0.990234H2.69181C1.4868 0.990234 0.511963 1.9429 0.511963 3.11835V28.4023C0.511963 29.5789 1.4868 30.5304 2.69181 30.5304H27.8641C29.0679 30.5304 30.0525 29.5789 30.0525 28.4023V3.11835C30.0525 1.9429 29.0679 0.990234 27.8641 0.990234H27.8678Z'
        />
      ),
    },
  ];

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <Container className={classes.contentWrapper}>
          {props.children}
        </Container>
      </div>
      <footer className={classes.footer}>
        {!!socials.length && (
          <Box className={classes.footerSocials}>
            {socials.map((social) => (
              <a key={social.title} href={social.url} target='_blank'>
                <SvgIcon viewBox='0 0 31 31'>{social.icon}</SvgIcon>
              </a>
            ))}
          </Box>
        )}
        <Typography className={classes.footerText}>
          <a href='mailto:hello@deliverinperson.com' target='_blank'>
            hello@deliverinperson.com
          </a>
        </Typography>
        <Typography className={classes.footerCopyrights}>
          If you have any questions please contact us on{' '}
          <a href='mailto:hello@deliverinperson.com' target='_blank'>
            hello@deliverinperson.com
          </a>
        </Typography>
      </footer>
    </>
  );
}
